import React, { useState } from 'react';
import { PushUniversalAccountButton, usePushWalletContext } from '@pushchain/ui-kit';
import './PushChainWallet.css';

const PushChainWallet = ({ pushChain }) => {
  const [showNFTs, setShowNFTs] = useState(false);
  const { address, isConnected } = usePushWalletContext();

  const formatAddress = (addr) => {
    if (!addr) return '';
    return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
  };

  const toggleNFTs = () => {
    setShowNFTs(!showNFTs);
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'Just now';
    const date = new Date();
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  // Mock NFT data for display (will be replaced with real data)
  const mockNFTs = pushChain?.mintedNFT ? [
    {
      tokenId: '1',
      score: 580,
      maxCombo: 12,
      tokensSliced: 58,
      totalSlashes: 120,
      timestamp: Date.now() / 1000
    }
  ] : [];

  return (
    <div className="pushchain-wallet">
      {/* Use Push UI Kit Button */}
      <PushUniversalAccountButton />
      
      {isConnected && (
        <>
          <button 
            className="wallet-nft-btn"
            onClick={toggleNFTs}
            title="View your NFTs"
            style={{ marginLeft: '8px' }}
          >
            NFTs
          </button>

          {showNFTs && (
            <div className="nft-dropdown">
              <div className="nft-dropdown-header">
                <h3>🎮 Your Game NFTs</h3>
              </div>

              <div className="nft-grid">
                {mockNFTs.length === 0 ? (
                  <div className="no-nfts">
                    <div className="no-nfts-icon">🎮</div>
                    <p>No NFTs yet</p>
                    <p className="no-nfts-hint">Play a game and mint your first achievement!</p>
                  </div>
                ) : (
                  mockNFTs.map((nft, index) => (
                    <div key={index} className="nft-card">
                      <div className="nft-card-header">
                        <div className="nft-card-icon">🎯</div>
                        <div className="nft-card-badge">#{nft.tokenId}</div>
                      </div>
                      
                      <div className="nft-card-body">
                        <div className="nft-stat-row">
                          <div className="nft-stat">
                            <div className="nft-stat-label">Score</div>
                            <div className="nft-stat-value">{nft.score}</div>
                          </div>
                          <div className="nft-stat">
                            <div className="nft-stat-label">Max Combo</div>
                            <div className="nft-stat-value">×{nft.maxCombo}</div>
                          </div>
                        </div>
                        
                        <div className="nft-stat-row">
                          <div className="nft-stat">
                            <div className="nft-stat-label">Tokens</div>
                            <div className="nft-stat-value">{nft.tokensSliced}</div>
                          </div>
                          <div className="nft-stat">
                            <div className="nft-stat-label">Slashes</div>
                            <div className="nft-stat-value">{nft.totalSlashes}</div>
                          </div>
                        </div>
                      </div>

                      <div className="nft-card-footer">
                        <div className="nft-date">
                          {formatTimestamp(nft.timestamp)}
                        </div>
                        <a 
                          href={`https://donut.push.network/address/${address}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nft-view-link"
                        >
                          View →
                        </a>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {mockNFTs.length > 0 && (
                <div className="nft-dropdown-footer">
                  <a 
                    href={`https://donut.push.network/address/${address}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="view-all-link"
                  >
                    View All on Push Explorer →
                  </a>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PushChainWallet;
